/* eslint-disable import/prefer-default-export */
import moment from 'moment';

export const DATA_INICIO_MOEDA_REAL = '01/07/1994';

const preencherCompetenciaFim = (lista) => {
  let retorno = null;
  if (lista.length > 0) {
    retorno = `${lista[lista.length - 1].mes}/${lista[lista.length - 1].ano}`;
  }
  return retorno;
};

export const pesquisarIndice = (lista, valor) => {
  const indice = lista.findIndex(item => (item.indice === valor));
  return indice;
};

export const apagarItemDaLista = (lista) => {
  const retorno = lista;
  const index = pesquisarIndice(retorno, undefined);
  if (index !== -1) {
    retorno.splice(index, 1);
  }
  return retorno;
};

export const validarDatasPeriodo = (atividadeDtInicio, atividadeDtFim, periodoDtInicio, periodoDtFim) => (
  (atividadeDtInicio.isSameOrBefore(atividadeDtFim)) && (atividadeDtInicio.isSameOrAfter(periodoDtInicio)) &&
  (atividadeDtInicio.isSameOrBefore(periodoDtFim)) && (atividadeDtFim.isSameOrAfter(periodoDtInicio)) &&
  (atividadeDtFim.isSameOrBefore(periodoDtFim))
);

export const recuperarAnosQuePossuemAlgumaRemuneracao = (anosQuePossuemAlgumaRemuneracao, remuneracoes) => {
  let ano = {};
  let competenciaInicioPreenchida = '';
  let competenciaFimPreenchida = '';
  const retorno = [];
  if (anosQuePossuemAlgumaRemuneracao && remuneracoes) {
    for (let i = 0, tamanhoI = anosQuePossuemAlgumaRemuneracao.length; i < tamanhoI; i += 1) {
      const anoComAlgumaRemuneracao = anosQuePossuemAlgumaRemuneracao[i].ano;
      competenciaInicioPreenchida = '';

      for (let j = 0, tamanhoJ = remuneracoes.length; j < tamanhoJ; j += 1) {
        const anoRemuneracao = remuneracoes[j].ano;

        if (anoComAlgumaRemuneracao === anoRemuneracao && competenciaInicioPreenchida === '') {
          competenciaInicioPreenchida = `${(remuneracoes[j].mes)}/${remuneracoes[j].ano}`;
        }

        if (anoComAlgumaRemuneracao !== anoRemuneracao) {
          const lista = remuneracoes.filter(r => r.ano === anoComAlgumaRemuneracao);
          competenciaFimPreenchida = preencherCompetenciaFim(lista);
        } else {
          competenciaFimPreenchida = `${remuneracoes[remuneracoes.length - 1].mes}/${remuneracoes[remuneracoes.length - 1].ano}`;
        }
      }

      if (competenciaFimPreenchida !== null) {
        ano = {
          ano: anoComAlgumaRemuneracao,
          competenciaInicio: competenciaInicioPreenchida,
          competenciaFim: competenciaFimPreenchida,
        };
        retorno.push(ano);
      }
    }
  }

  return retorno;
};

const verificarPeriodoDeducaoDoTempoCertificado = (dataInicio, dataFim, tempo) => {
  const deducao = {};
  const tempoCertificadoInicio = moment(dataInicio, 'DD/MM/YYYY').toDate();
  const tempoCertificadoFim = moment(dataFim, 'DD/MM/YYYY').toDate();
  const dtInicio = moment(tempo.dtInicio, 'DD/MM/YYYY').toDate();
  const dtFim = moment(tempo.dtFim, 'DD/MM/YYYY').toDate();

  if (tempoCertificadoInicio <= dtInicio && tempoCertificadoFim >= dtFim) {
    deducao.dataInicio = tempo.dtInicio;
    deducao.dataFim = tempo.dtFim;
  } else if (tempoCertificadoInicio <= dtInicio && tempoCertificadoFim >= dtInicio && tempoCertificadoFim <= dtFim) {
    deducao.dataInicio = tempo.dtInicio;
    deducao.dataFim = dataFim;
  } else if (tempoCertificadoInicio >= dtInicio && tempoCertificadoInicio <= dtFim && tempoCertificadoFim >= dtFim) {
    deducao.dataInicio = dataInicio;
    deducao.dataFim = tempo.dtFim;
  } else {
    deducao.dataInicio = null;
    deducao.dataFim = null;
  }
  return deducao;
};

export const calcularTotal = (dataInicio, dataFim) => {
  let total = 0;
  const inicio = moment(dataInicio, 'DD/MM/YYYY').toDate();
  const fim = moment(dataFim, 'DD/MM/YYYY').toDate();
  total = (moment(fim).diff(inicio, 'days') + 1);
  return total;
};

export const calcularTotalAfastamentos = (dataInicio, dataFim, afastamentos) => {
  let totalDeducao = 0;
  const deducoes = [];

  if (afastamentos && afastamentos !== null) {
    afastamentos.forEach((afastamento) => {
      deducoes.push(verificarPeriodoDeducaoDoTempoCertificado(dataInicio, dataFim, afastamento));
    });
  }

  deducoes.forEach((deducao) => {
    const inicio = deducao.dataInicio !== null ? moment(deducao.dataInicio, 'DD/MM/YYYY').toDate() : null;
    const fim = deducao.dataFim != null ? moment(deducao.dataFim, 'DD/MM/YYYY').toDate() : null;
    if (inicio !== null && fim !== null) {
      totalDeducao += (moment(fim).diff(inicio, 'days') + 1);
    }
  });

  return totalDeducao;
};



// WEBPACK FOOTER //
// ./src/utils/ctcHelpers.js